// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"787e7032","455":"8f1c74ea","817":"f377e118","863":"34677bc1","977":"0164e412"}[chunkId] + ".chunk.js";
};